import AOS from "aos";

export function aosInit() {
    AOS.init();
}

